import { render, staticRenderFns } from "./oldCertificate.vue?vue&type=template&id=739da2a6&scoped=true&"
import script from "./oldCertificate.vue?vue&type=script&lang=js&"
export * from "./oldCertificate.vue?vue&type=script&lang=js&"
import style0 from "./oldCertificate.vue?vue&type=style&index=0&id=739da2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739da2a6",
  null
  
)

export default component.exports